// // import { Constants } from "../config/constants";
// // import Cookies from 'js-cookie';
// //
// // // Initialize with safe defaults
// // let userScopes = [];
// // let userInfo = null;
// //
// // // const init = () => {
// // //     try {
// // //         const rawScopes = Cookies.get(Constants.STORAGE_USER_SCOPES);
// // //         const rawInfo = Cookies.get(Constants.STORAGE_USER_INFO);
// // //
// // //         // Check if cookies exist and are not the literal string "undefined"
// // //         userScopes = (rawScopes && rawScopes !== "undefined") ? JSON.parse(rawScopes) : [];
// // //         userInfo = (rawInfo && rawInfo !== "undefined") ? JSON.parse(rawInfo) : null;
// // //     } catch (error) {
// // //         // If JSON.parse fails, fallback to empty states to prevent app crash
// // //         console.error("Auth Service: Error parsing session cookies", error);
// // //         userScopes = [];
// // //         userInfo = null;
// // //     }
// // // };
// //
// // const init = () => {
// //     try {
// //         // We look in localStorage now because it has a 5MB limit
// //         const rawScopes = localStorage.getItem(Constants.STORAGE_USER_SCOPES);
// //         const rawInfo = localStorage.getItem(Constants.STORAGE_USER_INFO);
// //
// //         if (rawScopes && rawScopes !== "undefined") {
// //             userScopes = JSON.parse(rawScopes);
// //         } else {
// //             userScopes = [];
// //         }
// //
// //         if (rawInfo && rawInfo !== "undefined") {
// //             userInfo = JSON.parse(rawInfo);
// //         } else {
// //             userInfo = null;
// //         }
// //     } catch (error) {
// //         console.error("Auth Service: Error parsing session storage", error);
// //         userScopes = [];
// //         userInfo = null;
// //     }
// // };
// //
// // // export class Scope {
// // //     /**
// // //      * Checks if the user has specific permission scopes.
// // //      * Returns true if superAdmin or if any required scope is found.
// // //      */
// // //
// // //     static checkScopes = (scopes = []) => {
// // //         init();
// // //
// // //         // 1. Super Admin always gets access
// // //         if (userInfo && userInfo.superAdmin) return true;
// // //
// // //         // 2. Ensure userScopes is an array and has items
// // //         if (Array.isArray(userScopes) && userScopes.length > 0) {
// // //             return userScopes.some((v) => scopes.includes(v));
// // //         }
// // //
// // //         return false;
// // //     };
// // //
// // //     /**
// // //      * Checks if any user scope contains a parent string (partial match).
// // //      */
// // //     static checkScopesParent = (parent) => {
// // //         init();
// // //
// // //         if (userInfo && userInfo.superAdmin) return true;
// // //
// // //         if (Array.isArray(userScopes) && userScopes.length > 0) {
// // //             return userScopes.some((item) => item.includes(parent));
// // //         }
// // //
// // //         return false;
// // //     };
// // //
// // //     /**
// // //      * Simple check for superAdmin status
// // //      */
// // //     static checkSuperAdmin = () => {
// // //         init();
// // //         return !!(userInfo && userInfo.superAdmin);
// // //     };
// // // }
// //
// // export class Scope {
// //     /**
// //      * @param {Array} requiredScopes - The scopes needed for the component (e.g., ['dashboard_index'])
// //      * @param {Array} userPermissions - The permissions array from Redux (state.utilities.permissions)
// //      * @param {Object} userInfo - The user object from Auth service or Redux
// //      */
// //     static checkScopes = (requiredScopes = [], userPermissions = [], userInfo = null) => {
// //         // 1. Super Admin always gets access
// //         if (userInfo && userInfo.superAdmin) return true;
// //
// //         // 2. Ensure userPermissions is an array and has items
// //         if (Array.isArray(userPermissions) && userPermissions.length > 0) {
// //             return userPermissions.some((v) => requiredScopes.includes(v));
// //         }
// //
// //         return false;
// //     };
// //
// //     /**
// //      * Checks for partial matches (parent strings)
// //      */
// //     static checkScopesParent = (parent, userPermissions = [], userInfo = null) => {
// //         if (userInfo && userInfo.superAdmin) return true;
// //
// //         if (Array.isArray(userPermissions) && userPermissions.length > 0) {
// //             return userPermissions.some((item) => item.includes(parent));
// //         }
// //
// //         return false;
// //     };
// //
// //     /**
// //      * Simple check for superAdmin status
// //      */
// //     static checkSuperAdmin = (userInfo) => {
// //         return !!(userInfo && userInfo.superAdmin);
// //     };
// // }
//
// import { Constants } from "../config/constants";
//
// /**
//  * These variables hold the current session data.
//  * They are updated every time a check is performed via the init() function.
//  */
// let userScopes = [];
// let userInfo = null;
//
// /**
//  * Bridges the gap between your storage and the Service.
//  * We use localStorage here because it bypasses the 4KB browser cookie limit.
//  */
//
// // const init = () => {
// //     try {
// //         const rawScopes = localStorage.getItem(Constants.STORAGE_USER_SCOPES);
// //         const rawInfo = localStorage.getItem(Constants.STORAGE_USER_INFO);
// //
// //         // Parse Scopes: Fallback to empty array if missing or "undefined" string
// //         userScopes = (rawScopes && rawScopes !== "undefined")
// //             ? JSON.parse(rawScopes)
// //             : [];
// //
// //         // Parse User Info: Fallback to null if missing or "undefined" string
// //         userInfo = (rawInfo && rawInfo !== "undefined")
// //             ? JSON.parse(rawInfo)
// //             : null;
// //
// //     } catch (error) {
// //         // If JSON is malformed, we reset to safe defaults to prevent app crashes
// //         console.error("Scope Service Error: Failed to parse session storage", error);
// //         userScopes = [];
// //         userInfo = null;
// //     }
// // };
//
// const init = () => {
//     try {
//         const rawScopes = localStorage.getItem(Constants.STORAGE_USER_SCOPES);
//         const rawInfo = localStorage.getItem(Constants.STORAGE_USER_INFO);
//
//         userScopes = (rawScopes && rawScopes !== "undefined") ? JSON.parse(rawScopes) : [];
//
//         // This is the critical part for Super Admin
//         userInfo = (rawInfo && rawInfo !== "undefined") ? JSON.parse(rawInfo) : null;
//
//         // DEBUG: Uncomment the line below to see if superAdmin is actually true in your console
//         // console.log("Current User Info:", userInfo);
//     } catch (error) {
//         console.error("Scope Service Error", error);
//         userScopes = [];
//         userInfo = null;
//     }
// };
//
// export class Scope {
//     /**
//      * Checks if the user has specific permission scopes.
//      * Use case: Scope.checkScopes(['dashboard_index'])
//      */
//     static checkScopes = (scopes = []) => {
//         init();
//
//         // 1. Super Admin always gets access
//         if (userInfo && userInfo.superAdmin) return true;
//
//         // 2. Ensure userScopes is an array and check for matches
//         if (Array.isArray(userScopes) && userScopes.length > 0) {
//             return userScopes.some((v) => scopes.includes(v));
//         }
//
//         return false;
//     };
//
//     /**
//      * Checks if any user scope contains a parent string (partial match).
//      * Use case: Scope.checkScopesParent('user-management')
//      */
//     static checkScopesParent = (parent) => {
//         init();
//
//         if (userInfo && userInfo.superAdmin) return true;
//
//         if (Array.isArray(userScopes) && userScopes.length > 0) {
//             return userScopes.some((item) => item.includes(parent));
//         }
//
//         return false;
//     };
//
//     /**
//      * Simple utility to check for superAdmin status
//      */
//     static checkSuperAdmin = () => {
//         init();
//         return !!(userInfo && userInfo.superAdmin);
//     };
// }


import { Constants } from "../config/constants";

let userScopes = [];
let userInfo = null;

const init = () => {
    try {
        const rawScopes = localStorage.getItem(Constants.STORAGE_USER_SCOPES);
        const rawInfo = localStorage.getItem(Constants.STORAGE_USER_INFO);

        userScopes = (rawScopes && rawScopes !== "undefined") ? JSON.parse(rawScopes) : [];
        userInfo = (rawInfo && rawInfo !== "undefined") ? JSON.parse(rawInfo) : null;
    } catch (error) {
        console.error("Scope Service Error", error);
        userScopes = [];
        userInfo = null;
    }
};

export class Scope {
    /**
     * Checks if the user has specific exact permission scopes.
     * Usage: Scope.checkScopes(['dashboard_index'])
     */
    static checkScopes = (scopes = []) => {
        init();

        // 1. Super Admin always gets access
        if (userInfo && userInfo.superAdmin) return true;

        // 2. Ensure userScopes is an array and check for exact matches
        if (Array.isArray(userScopes) && userScopes.length > 0) {
            return userScopes.some((v) => scopes.includes(v));
        }

        return false;
    };

    /**
     * Checks if any user scope contains or matches parent string(s).
     * Works with both a single string: Scope.checkScopesParent('academic_')
     * AND an array of strings: Scope.checkScopesParent(['academic_setup_', 'routines_'])
     */
    static checkScopesParent = (parent) => {
        init();

        if (userInfo && userInfo.superAdmin) return true;

        if (Array.isArray(userScopes) && userScopes.length > 0) {
            // Normalize parent input so it's always an array
            const parentList = Array.isArray(parent) ? parent : [parent];

            // Check if ANY scope held by the user matches or partially matches ANY requirement
            return userScopes.some((userScope) =>
                parentList.some((p) => userScope.includes(p) || p.includes(userScope))
            );
        }

        return false;
    };

    /**
     * Simple utility to check for superAdmin status
     */
    static checkSuperAdmin = () => {
        init();
        return !!(userInfo && userInfo.superAdmin);
    };
}